import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import HoverRightArrow from "web/assets/images/dropdown-menu-hover-arrow.png";

import './dropDownMenu.scss';

function DropDownMenuPost(props) {
  const [click, setClick] = useState(false);

  const storedData = useSelector(
    (state) => state.storedData.payload
  );
  let disableFlg = storedData?.guestUser
 
  const handleClick = () => setClick(!click);
  const userType = localStorage.getItem('accountType')
  let MenuItems;
  if(disableFlg){
    MenuItems = [
      {
        title: 'Post Needs',
        path:'/post-my-pallet-needs',
        cName: 'dropdown-link'
      },
      {
        title: 'Post Inventory',
        path:'/post-my-pallet-inventory',
        cName: 'dropdown-link'
      }
    ];
  }else{
    if (userType === "Both") {
      MenuItems = [
        {
          title: 'Post Needs',
          path:'/post-my-pallet-needs',
          //path: '/Post-Load?type=PostLoad&activePage=PostLoad&activeSearch=Dashboard&expanded=panel1',
          cName:'dropdown-link'
        },
        {
          title: 'Post Inventory',
          path:'/post-my-pallet-inventory',
          //path: '/Post-Inventory?type=PostInventory&activePage=PostInventory&expanded=panel2',
          cName:'dropdown-link'
        }
      ];
    }
    else if (userType === "Seller") {
      MenuItems = [
        {
          title: 'Post Inventory',
          path:'/post-my-pallet-inventory',
          //path: '/Post-Inventory?type=PostInventory&activePage=PostInventory&expanded=panel2',
          cName:'dropdown-link'
        }
      ];
    }
    else if (userType === "Buyer") {
      MenuItems = [
        {
          title: 'Post Needs',
          path:'/post-my-pallet-needs',
          //path: '/Post-Load?type=PostLoad&activePage=PostLoad&activeSearch=Dashboard&expanded=panel1',
          cName:'dropdown-link'
        }
      ];
    } else {
      MenuItems = [
        {
          title: 'Post Needs',
          path:'/post-my-pallet-needs',
          //: '/Post-Load?type=PostLoad&activePage=PostLoad&activeSearch=Dashboard&expanded=panel1',
          cName: 'dropdown-link'
        },
        {
          title: 'Post Inventory',
          path:'/post-my-pallet-inventory',
          //path: '/Post-Inventory?type=PostInventory&activePage=PostInventory&expanded=panel2',
          cName: 'dropdown-link'
        }
      ];
    }
  }
  const dispatch = useDispatch()
  return (
    <>
      <ul
        onClick={handleClick}
        className={click ? 'dropdown-menu1 clicked' : 'dropdown-menu1'}
      >
        {MenuItems.map((item, index) => {
          return (
            <li key={index}>
              {disableFlg?
              <div
                className='opacityDisable'
              >
                <img
                  className="arrow-image"
                  src={HoverRightArrow}
                  alt="right-arrow"
                />
                {item.title}
              </div>
            :
              <Link
                  className={item.cName}
                  exact
                  to={item.path}
                >
                  <img
                    className="arrow-image"
                    src={HoverRightArrow}
                    alt="right-arrow"
                  />
                  {item.title}
                </Link>
              }
            </li>
          );
        })}
      </ul>
    </>
  );
}

export default DropDownMenuPost;